import React, { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import AllApplyedGreen from './AllApplyedGreen';
import AllArchiveGreen from './AllArchiveGreen';

const AllApplicationGreenDetails = () => {
  const postData = useLoaderData();
  const [active, setActive] = useState('content1');

  return (
    <div className='bg-white h-screen py-4 w-full'>
        <div className="flex justify-between space-x-4 mb-4 w-full bg-green-500  rounded py-4 px-4">
          <div className='flex gap-5'>
          <button
          className={`py-2 px-6 font-montserrat text-lg text500 rounded ${active === 'content1' ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => setActive('content1')}
        >
          All Applied CV
        </button>
        <button
          className={`py-2 px-6 font-montserrat text-lg text500 rounded ${active === 'content2' ? 'bg-green-900 text-white' : 'bg-gray-50'}`}
          onClick={() => setActive('content2')}
        >
          Archived CV
        </button>
        
    
      </div>
      </div>
     
      <div className='mt-4 '>
        {active === 'content1' && (
          <AllApplyedGreen postData={postData}></AllApplyedGreen>
        )} 
        {active === 'content2' && (
          <AllArchiveGreen postData={postData}></AllArchiveGreen>
        )}
      </div> 
    </div>
  );
};

export default AllApplicationGreenDetails;
